export const paymentTypeConstants = [
  { name: "Pre", value: "pre" },
  { name: "Post", value: "post" },
];
